export default "__VITE_PUBLIC_ASSET__97621cbd__"